import { render, staticRenderFns } from "./EditionDetails.vue?vue&type=template&id=4de07a16&"
import script from "./EditionDetails.vue?vue&type=script&lang=js&"
export * from "./EditionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports